import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/loader/loader.component.ts